var map = {
	"./japanLogin1.webp": 67995,
	"./japanLogin2.webp": 23898,
	"./japanLogin3.webp": 37925,
	"./japanLogin4.webp": 77716,
	"./japanLogin5.webp": 62423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53462;